export default __webpack_public_path__ + "static/media/Aptos-Display.aaad6fca.ttf";